
// The Tender submission edit functions
var TECL_UserTenderSubmissionEdit = {

  // Initialise the Tenders edit page
  Initialise: function() {

    // Hide the button columns
    $(".tenderSupplierSummaryButtonsCol").each(function() {
      $(this).addClass("hidden");
    });

    // Change the sorting type
    $("#ddlTenderSummariesSortOrder").change(function() {
      TECL_UserTenderGeneric.ChangeSummarySortOrder();
    });

    TECL_Master.StopKendoDropDownScrollBug();

    $("#continueDialogContinueBtn").click(function() {
      TECL_UserTenderSubmissionEdit.ContinueSelected();
      $("#continueDialog").modal("hide");
    });
    
    var jumpPoint = $("#JumpPoint").val();
    if (jumpPoint && jumpPoint == 1) {
      $("html,body").animate({ scrollTop: $("#scrollToSupplierMarker").offset().top }, "slow");
    } else {
      window.scrollTo(0, 0);
    }
  },

  // Validate the current page
  ValidatePage: function() {
    var items = $(".tenderSupplierTenderRowItem");
    var isValid = items && items.length > 0;

    var mvSt = $("#SMST").val();
    if (mvSt > 0) {
      isValid = false;
    }
    return isValid;
  },

  // Display the continue dialog
  DisplayContinueDialog: function() {
    var isValid = TECL_UserTenderSubmissionEdit.ValidatePage();

    if (isValid) {
      $("#continueDialog").modal("show");
    }
  },

  // Submission continue button selected 
  ContinueSelected: function() {
    var tenderId = $("#TenderId").val();

    if (tenderId) {

      if (TECL_Master.AddLock("ContinueSelectedOnSubmission")) {
        $.ajax({
          url: baseSiteUrl + "TenderUserSurface/ContinueSelectedOnSubmission",
          dataType: "json",
          type: "POST",
          data: {
            tenderId: tenderId
          },
          error: function() {
            TECL_Master.ClearLock("ContinueSelectedOnSubmission");
          },
          success: function(saveData) {
            TECL_Master.ClearLock("ContinueSelectedOnSubmission");
            if (saveData && saveData.Saved === true && saveData.NextStageUrl) {
              window.location = saveData.NextStageUrl;
            } else {
              TECL_Master.ShowErrorDialog("Failed to save stage change.");
            }
          }
        });
      }
    }
  }

};
